/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';

// --- Imports from your project structure ---
import {
  Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  ButtonContainer,
} from '../CreateEvent/style';
import { FormHeading } from '../ChallengeCreationAdmin/ActivityChallengeLaunch/style';
import { Main } from '../AdminTeamCreation/styles';
import { Layout } from '../EditWellnessJourney/styles';
import { Border } from '../Journeys/styles';
import { ManagerIconContainer } from '../Manager/styles';
import { CommonButtonPopup } from '../ReportsV2/styles';
import { CommonButtonBorder } from '../common/commonStyles';
import { ImageUrl } from '../../utils/constants';
import CommonImageUploader from '../common/CommonImageUploader/CommonImageUploader';
import CommonDropdown from '../common/CommonDropDown/CommonDropdown';
import { fetchApi, getMonthName } from '../../utils/methods';
import { GetWellnessGoals, GetQuestionByCategoryId, GetWellbeingPillars, AddVideoByCategory } from '../../redux/constants/apiConstants';
import { RecognitionCloseIcon, UploadIcon, closeIcon } from '../../utils/icons';

const StyledTextArea = styled.textarea`
  width: 100%;
  min-height: 100px;
  padding: 12px;
  border: 1px solid ${(props) => (props.error ? '#F44336' : '#BDBDBD')};
  border-radius: 4px;
  font-family: 'Lato', sans-serif;
  font-size: 16px;
  color: #184A61;
  resize: vertical;
  outline: none;
  background: white;
  transition: border-color 0.2s ease-in-out;

  &::placeholder { 
    color: #BDBDBD; 
  }

  &:focus {
    border-color: #184A61;
  }

  &:disabled {
    background: #f8f8f8;
    cursor: not-allowed;
  }
`;

const CategoryGrid = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
`;

const CategoryChip = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 15px;
  border: 1px solid ${(props) => (props.active ? '#DA6C74' : '#E0E0E0')};
  background-color: ${(props) => (props.active ? '#DA6C74' : '#FFFFFF')};
  border-radius: 50px; /* Pill shape */
  cursor: pointer;
  transition: all 0.2s;
  min-width: 120px;

  &:hover {
    border-color: #DA6C74;
  }
`;

const CategoryText = styled.span`
  font-size: 16px;
  font-weight: ${(props) => (props.active ? '500' : '400')};
  color: ${(props) => (props.active ? '#fff' : '#184A61')};
  display: flex;
  align-items: center;

  img{
   background: ${(props) => (props.active ? '#fff' : '#fff')};
  };
`;

const UrlValidationMessage = styled.div`
  color: ${(props) => (props.isValid ? '#4CAF50' : '#F44336')};
  font-size: 12px;
  margin-top: 4px;
  font-family: 'Lato', sans-serif;
`;

const StepCircle = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${(props) => (props.active ? '#092F41' : '#F8F8F8')}; 
  /* Active: White (#FEFEFE)
     Completed: Dark Blue (#184A61)
     Incomplete: Grey (#BDBDBD) 
  */
  color: ${(props) => {
    if (props.active) return '#FEFEFE';
    if (props.completed) return '#184A61';
    return '#BDBDBD';
  }};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
`;

const StepText = styled.div`
  /* Active or Completed: Dark Blue (#184A61)
     Incomplete: Grey (#BDBDBD) 
  */
  color: ${(props) => (props.active || props.completed ? '#184A61' : '#BDBDBD')};
  font-weight: ${(props) => (props.active ? '700' : '700')};
  font-size: 18px;
  font-Family: 'Lato';
`;

class FormAddVideo extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      ...props.state,
      description: props.state.description || "",
      step: 1,
      wellnessGoals: [],
      wbaQuestions: [],
      showWbaQue: false,
      isLoadingQuestions: false,
      urlValid: true,
      charCount: props.state.description ? props.state.description.length : 0,
      themeOpen: false,
      goalOpen: false,
      questionOpen: false,
      muscleGroupOpen: false,
      fitnessLevelOpen: false,
      themeName: "",
      themeMonth: "",
      theme_id: null,
      wellbeingPillars:[],
      selectedMuscleGroup:null,
      selectedFitnessLevel:null
    };
  }

  componentDidMount() {
    this.getWellnessGoals();
    this.getAllWellbeingPillars()
  }

  getAllWellbeingPillars = async () => {
    // setIsLoading(true);
    try {
      const res = await fetchApi(GetWellbeingPillars , "GET");

      if (res.status === "success") {
        // setWellbeingPillars(res.data);
        this.setState({wellbeingPillars:res?.data})
        // setIsLoading(false);
      } else {
        toast.error(res.data.message || "Something went wrong");
        // setIsLoading(false);s

      }
    } catch (error) {
      window.console.error(error);
      // setIsLoading(false);
    }
  };

  componentDidUpdate(prevProps) {
    // Sync description if props change (e.g. data loaded in parent)
    if (this.props.state.description !== prevProps.state.description) {
      const newDesc = this.props.state.description || "";
      this.setState({
        description: newDesc,
        charCount: newDesc.length
      });
    }

    // Sync other fields if necessary
    if (this.props.state.title !== prevProps.state.title) {
      this.setState({ title: this.props.state.title || "" });
    }
    if (this.props.state.video_url !== prevProps.state.video_url) {
      this.setState({ video_url: this.props.state.video_url || "" });
    }
  }

  // --- API Methods ---

  getWellnessGoals = async () => {
    try {
      const res = await fetchApi(`${GetWellnessGoals}`, "GET", null, {});
      if (res && res.data) {
        this.setState({ wellnessGoals: res.data });
        
        if (this.props.state.wellness_goal) {
          const selectedGoal = res.data.find((g) => g.id === this.props.state.wellness_goal);
          if (selectedGoal) {
            this.setState({ wellness_goal: selectedGoal });
            this.getWBAQuestions(selectedGoal.id);
          }
        }
      }
    } catch (error) {
      toast.error(error.message);
    }
  }

  getWBAQuestions = async (categoryId) => {
    this.setState({ isLoadingQuestions: true });
    try {
      const res = await fetchApi(`${GetQuestionByCategoryId + "/" + categoryId}`, "GET", null, {});
      if (res && res.data && res.data.length > 0) {
        const formattedQuestions = res.data.map((item) => ({
          ...item,
          displayLabel: item.question || item.question_text || `Question ${item.id}`,
        }));
        this.setState({ wbaQuestions: formattedQuestions, showWbaQue: true });
      } else {
        this.setState({ wbaQuestions: [], showWbaQue: false });
      }
    } catch (error) {
      // toast.error('Failed to load questions'); 
    } finally {
      this.setState({ isLoadingQuestions: false });
    }
  }

  // --- Input Handlers ---

  onChangeInput = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });

    if (name === 'description') {
      this.setState({ charCount: value ? value.length : 0 });
    }
    if (name === 'video_url') {
      this.validateUrl(value);
    }
  };

  validateUrl = (url) => {
    const pattern = /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/;
    const isValid = url ? pattern.test(url) : true;
    this.setState({ urlValid: isValid });
    return isValid;
  };

  handleImageChange = (imgSrc) => {
    this.setState({ thumbnail_image: imgSrc });
  };

  handleRemoveImage = () => {
    this.setState({ thumbnail_image: "" });
  };

  toggleCategory = (id) => {
    const { video_category_ids } = this.state;
    let newIds = [...(video_category_ids || [])];
    
    if (newIds.includes(id)) {
      newIds = newIds.filter((item) => item !== id);
    } else {
      newIds.push(id);
    }
    this.setState({ video_category_ids: newIds });
  };

  // --- Dropdown Selection Handlers ---

  onSelectMuscleGroup = (item) => this.setState({ muscle_group: item.id, muscleGroupOpen: false,selectedMuscleGroup:item });
  
  onSelectFitnessLevel = (item) => this.setState({ fitness_level: item.id, fitnessLevelOpen: false, selectedFitnessLevel:item});
  
  onSelectTheme = (item) => {
    this.setState({selectedWellbeingPillar:item});
  };

  onSelectGoal = (item) => {
    this.setState({ wellness_goal: item, goalOpen: false, question: null }, () => {
      this.getWBAQuestions(item.id);
    });
  };

  onSelectQuestion = (item) => this.setState({ question: item, questionOpen: false });
  
  // --- Navigation & Validation ---

  isStepValid = () => {
    const { step, title, thumbnail_image, video_url, description, video_category_ids, urlValid } = this.state;
    
    if (step === 1) {
      const safeDesc = description || "";
      return (
        title && title.trim() !== '' &&
        thumbnail_image && 
        video_url && video_url.trim() !== '' && urlValid &&
        safeDesc && safeDesc.trim() !== ''
      );
    }
    if (step === 2) {
      return video_category_ids && video_category_ids.length > 0;
    }
    return false;
  };

  nextStep = () => {
    if (this.isStepValid()) {
      this.setState((prev) => ({ step: prev.step + 1 }));
      window.scrollTo(0, 0);
    } else {
      toast.error(this.props.t('Please fill all mandatory fields correctly'));
    }
  };

  prevStep = () => {
    this.setState((prev) => ({ step: prev.step - 1 }));
    window.scrollTo(0, 0);
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.props.isSubmitting) return;

    if (this.isStepValid()) {
      // this.props.onSubmit(e, this.state);
      const{description, title,thumbnail_image,video_url,video_category_ids,selectedWellbeingPillar,wellness_goal,question,/*level,*/imgSrc,selectedMuscleGroup,selectedFitnessLevel}= this.state;
      const payload = {
        month:selectedWellbeingPillar?.id,
        description, 
        title,
        thumbnail_image:thumbnail_image || imgSrc,video_url,
        video_categories:video_category_ids,
        wellness_goal_id:wellness_goal?.id,
        question_id:question?.id,
        // levels:level.level,
        fitness_level:selectedFitnessLevel?.category_name,
        muscle_group:selectedMuscleGroup?.category_name
      }
      this.createFitnessVideo(payload);
    } else {
      toast.error(this.props.t('Please select at least one category'));
    }
  }

  

  createFitnessVideo = async (payload) => {
    const{history}=this.props;
    const fromAdmin =history?.location?.state?.route  === "admin";
    this.setState({ isDisabled: true }); 
    try {
      const res = await fetchApi("/" + AddVideoByCategory , "POST",payload);
      if (res.status === "success") {
        if(fromAdmin){
          history.push("/company/wellness",{ activeTab: "Library",activeLibraryTab: "Fitness"});
        }else{
          history.push('/wellness-resources');
        }
        // this.props.history.push(`/wellness-resources`);
      } else {
        toast.error(res.data.message || "Something went wrong");
      }
    } catch (error) {
      window.console.error(error);
    }finally{
      this.setState({ isDisabled: false }); 
    }
  };

  // --- Render Helpers ---

  renderStepOne = () => {
    const { t } = this.props;
    const { title, video_url, description, charCount, thumbnail_image, urlValid } = this.state;

    // Ensure we render an empty string if description is null/undefined
    const displayDescription = description || "";

    return (
      <div className="formBody">
        {/* Title */}
        <InputContainer>
          <StyledLabel isFont="16px" color="#184A61" margin="0px" symbolSize="16px">
            {t('Fitness Video Title')}<span>*</span>
          </StyledLabel>
          <StyledInputV2
            placeholder={t('Enter fitness video title')}
            name="title"
            onChange={this.onChangeInput}
            value={title || ""}
            maxLength="100"
            border="0.75px solid #BDBDBD"
          />
          <div className="count">{title ? title.length : 0}/100 | C</div>
        </InputContainer>

        <Border style={{ background: '#EFEFEF', margin: '8px 0' }} />

        {/* Thumbnail */}
        <StyledLabel isFont="16px" color="#184A61" margin="0px 0px 12px 0px" symbolSize="16px">
          {t('Fitness video Thumbnail')}<span>*</span>
        </StyledLabel>
        <CommonImageUploader
          imgSrc={thumbnail_image}
          t={t}
          closeIcon={closeIcon}
          UploadIcon={UploadIcon}
          onImageChange={this.handleImageChange}
          onRemoveImage={this.handleRemoveImage}
        />

        <Border style={{ background: '#EFEFEF', margin: '20px 0' }} />

        {/* URL */}
        <InputContainer>
          <StyledLabel isFont="16px" color="#184A61" margin="0px" symbolSize="16px">
            {t('Fitness Video URL')}<span>*</span>
          </StyledLabel>
          <StyledInputV2
            placeholder={t('Enter fitness video URL')}
            name="video_url"
            onChange={this.onChangeInput}
            value={video_url || ""}
            border={`0.75px solid ${urlValid ? '#BDBDBD' : '#F44336'}`}
          />
          {!urlValid && video_url && (
            <UrlValidationMessage isValid={false}>{t('Invalid URL format')}</UrlValidationMessage>
          )}
        </InputContainer>

        <Border style={{ background: '#EFEFEF', margin: '8px 0' }} />

        {/* Description */}
        <InputContainer isColorError={charCount > 3000}>
          <StyledLabel isFont="16px" color="#184A61" margin="0px" symbolSize="16px">
            {t('Fitness video Description')}<span>*</span>
          </StyledLabel>
          
          <StyledTextArea
            name="description"
            placeholder={t('Write your fitness video description here')}
            value={displayDescription}
            onChange={this.onChangeInput}
            maxLength={3000}
            error={false} 
          />
          
          <div className="count">{charCount}/3000 | C</div>
        </InputContainer>
      </div>
    );
  };

  renderStepTwo = () => {
    const { t, video_category_id, muscle_group, fitness_level, /*themesHeaderAll*/ } = this.props;
    const { 
      video_category_ids, 
      // muscle_group: selectedMuscle, 
      // fitness_level: selectedFitness,
      // theme_id,
      // themeName,
      // themeMonth,
      wellness_goal,
      question,
      wellnessGoals, wbaQuestions, showWbaQue,
      muscleGroupOpen, fitnessLevelOpen, themeOpen, goalOpen, questionOpen, isLoadingQuestions,
      wellbeingPillars,
      selectedWellbeingPillar,
      selectedMuscleGroup,
      selectedFitnessLevel
    } = this.state;

    // Helper to close all other dropdowns when one opens
    const toggleDropdown = (stateKey) => {
      const keys = ['muscleGroupOpen', 'fitnessLevelOpen', 'themeOpen', 'goalOpen', 'questionOpen'];
      const newState = {};
      keys.forEach((k) => { newState[k] = (k === stateKey) ? !this.state[k] : false; });
      this.setState(newState);
    };

    // Prepare Dropdown Data
    const muscleData = [
      { id: "", category_name: t("None") }, 
      ...(muscle_group || []).filter((m) => m.category_name !== "None" && m.id !== "")
    ];

    const fitnessData = [
      { id: "", category_name: t("None") }, 
      ...(fitness_level || []).filter((f) => f.category_name !== "None" && f.id !== "")
    ];

    // Sorting Logic for Monthly Themes
    // const monthOrder = {
    //   "January": 1, "February": 2, "March": 3, "April": 4, 
    //   "May": 5, "June": 6, "July": 7, "August": 8, 
    //   "September": 9, "October": 10, "November": 11, "December": 12
    // };

    // let sortedThemes = [];
    // if (themesHeaderAll && themesHeaderAll.length > 0) {
    //   sortedThemes = [...themesHeaderAll].sort((a, b) => {
    //     const monthA = a.month ? monthOrder[a.month] || 99 : 99;
    //     const monthB = b.month ? monthOrder[b.month] || 99 : 99;
    //     return monthA - monthB;
    //   });
    // }

    // const themeOptions = sortedThemes.length > 0 
    //   ? [{ id: null, theme_text: "", displayLabel: t("None") }, ...sortedThemes.map((theme) => ({
    //     ...theme,
    //     displayLabel: theme.month ? `${theme.month}, ${theme.theme_text}` : theme.theme_text
    //   }))]
    //   : [{ id: null, theme_text: "", displayLabel: t("No Themes Available") }];

    const goalData = [{ id: null, name: t("None") }, ...(wellnessGoals || [])];
    const questionData = wbaQuestions.map((q) => ({ ...q, displayLabel: q.question || q.question_text }));

    // let themeTitle = themeName || "";
    // if (themeName && themeMonth) {
    //   themeTitle = `${themeMonth}, ${themeName}`;
    // }

    return (
      <div className="formBody">
        {/* Categories Grid */}
        <StyledLabel isFont="16px" color="#184A61" margin="0px 0px 12px 0px" symbolSize="16px">
          {t('Select category')}<span>*</span>
        </StyledLabel>
        <CategoryGrid>
          {video_category_id && video_category_id.map((cat) => (
            <CategoryChip 
              key={cat.id} 
              active={video_category_ids.includes(cat.id)}
              onClick={() => this.toggleCategory(cat.id)}
            >
              <CategoryText active={video_category_ids.includes(cat.id)}>
                <span>
                  {cat.image && <img src={ImageUrl + "/" + cat.image} alt="" style={{ width: 24, height: 24, marginRight: 8, borderRadius: '50%' }} />}
                </span>
                <span>{cat.category_name}</span>
              </CategoryText>
            </CategoryChip>
          ))}
        </CategoryGrid>

        <Border style={{ background: '#EFEFEF', margin: '8px 0' }} />

        {/* Row 1: Muscle & Fitness Level */}
        <div style={{ display: 'flex', gap: '20px' }}>
          <div style={{ flex: 1 }}>
            <CommonDropdown
              tileContainerStyle={{ width: '100%' }}
              labelText={t("Muscles focus")}
              dropdownOpen={muscleGroupOpen}
              title={selectedMuscleGroup?.category_name || t('None')}
              onClick={() => toggleDropdown('muscleGroupOpen')}
              data={muscleData}
              onSelect={this.onSelectMuscleGroup}
              // active={selectedMuscle}
              onSelectParameter={['category_name']}
              itemValue valueIndex={0} valueString=""
              noBorder
              dropIcon
              labelMargin={"0px"}
              margin={'0px'}
            />
          </div>

          <div style={{ flex: 1 }}>
            <CommonDropdown
              tileContainerStyle={{ width: '100%' }}
              labelText={t("Fitness Level")} 
              dropdownOpen={fitnessLevelOpen}
              title={selectedFitnessLevel?.category_name || t('None')}
              onClick={() => toggleDropdown('fitnessLevelOpen')}
              data={fitnessData}
              onSelect={this.onSelectFitnessLevel}
              // active={selectedFitness}
              onSelectParameter={['category_name']}
              itemValue 
              valueIndex={0} 
              valueString="" 
              noBorder 
              dropIcon
              labelMargin={"0px"}
              margin={'0px'}
            />
          </div>
        </div>
        <Border style={{ background: '#EFEFEF', margin: '8px 0 10px' }} />
        
        {/* Row 2: Theme */}
        <div>
          <CommonDropdown
            tileContainerStyle={{ width: "100%", padding: "0px 0px 12px 0px" }}
            dropdownStyle={{ top: "90px" }}
            labelText={t("Monthly theme")} 
            dropdownOpen={themeOpen}
            placeholder={ wellbeingPillars?.length > 0 ? t("Select monthly theme (optional)") : t("No Themes Available")}
            // title={themeTitle}
            title={(selectedWellbeingPillar?.pillar_title) ? ` ${getMonthName(selectedWellbeingPillar?.id) + " - " + selectedWellbeingPillar?.pillar_title}` : t('Select theme')}
            id="dropdown-monthly-theme"
            onClick={() => toggleDropdown('themeOpen')}
            data={wellbeingPillars}
            onSelect={this.onSelectTheme}
            // active={theme_id}
            // onSelectParameter={["displayLabel", "id", "theme_text", "month"]}
            onSelectParameter={['pillar_title','id']}
            valueString={""}
            itemValue={true}
            valueIndex={0}
            dropIcon={true}
            labelMargin={"0px"}
            fontSize={"16px"}
            margin={'0px'}
            showMonthName={true}
          />
        </div>
        
        {/* Row 3: Wellness Goal */}
        <div style={{position:'relative', top:'-30px'}}>
          <CommonDropdown
            tileContainerStyle={{ width: '100%' }}
            labelText={t("Wellness Goal")} 
            dropdownOpen={goalOpen}
            title={wellness_goal?.name || t('None')}
            onClick={() => toggleDropdown('goalOpen')}
            data={goalData}
            style={{margin:'0 !important'}}
            onSelect={this.onSelectGoal}
            active={wellness_goal?.id}
            onSelectParameter={['name']}
            margin={'0px'}
            itemValue valueIndex={0} valueString="" noBorder dropIcon
          />
        </div>
        
        {/* Conditional Rows: Question */}
        {showWbaQue && wellness_goal && (
          <div style={{position:'relative', top:'-30px'}}>
            <CommonDropdown 
              tileContainerStyle={{ width: '100%' }}
              labelText={t("Question (WBA)")} 
              dropdownOpen={questionOpen}
              title={question?.question || question?.question_text || t('Select Question')}
              onClick={() => toggleDropdown('questionOpen')}
              data={questionData}
              onSelect={this.onSelectQuestion}
              active={question?.id}
              onSelectParameter={['displayLabel']}
              labelMargin={"0px"}
              margin={'0px'}
              itemValue valueIndex={0} valueString="" noBorder dropIcon isLoading={isLoadingQuestions}
            />
          </div>
        )}
      </div>
    );
  };

  redirect = () => {

    const{history}=this.props;
    const fromAdmin =history?.location?.state?.route  === "admin";
  
    if (fromAdmin) {
      this.props.history.push("/company/wellness",{ activeTab: "Library",activeLibraryTab: "Fitness"});
    } else {
      this.props.history.goBack();
    }
  };




  render() {
    const { step } = this.state;
    const { buttonText, t, isSubmitting } = this.props;
    const isValid = this.isStepValid();

    return (
      <Layout>
        <div className="main">
          {/* Header */}
          <FormHeading color="#184A61">
            <div className="close-icon" /*onClick={() => history.goBack()}*/  onClick={this.redirect}>
              <ManagerIconContainer isWidth="32px">{RecognitionCloseIcon('#F37A65')}</ManagerIconContainer>
            </div>
            {t('Create Fitness Videos')}
          </FormHeading>

          <Container height="100%" stepBackground="#005C87" color="#005C87" paddingForm>
            {/* Sidebar Steps */}
            <div className="stepsNameHighlight">
              <div style={{ padding: "20px 20px", width:'100%', background:'#fff', borderRadius:'12px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                  
                  {/* Step 1 */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <StepCircle active={step === 1} completed={step > 1}>1</StepCircle>
                    <StepText active={step === 1} completed={step > 1}>{t('About Fitness')}</StepText>
                  </div>
                  
                  <div  style={{border:'0.75px solid #efefef',width:'100%' }}></div>
                  
                  {/* Step 2 */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <StepCircle active={step === 2}>2</StepCircle>
                    <StepText active={step === 2}>{t('Customize Fitness')}</StepText>
                  </div>

                </div>
              </div>
            </div>

            {/* Form Content */}
            <div className="form">
              <form onSubmit={this.handleSubmit}>
                {step === 1 && this.renderStepOne()}
                {step === 2 && this.renderStepTwo()}
              </form>
            </div>
          </Container>

          {/* Footer Buttons */}
          <ButtonContainer style={{ width: '100%', left: '0' }}>
            <Main>
              <div className="wrapper" style={{ display: 'flex', width: '100%', justifyContent: 'flex-end', gap: '15px' }}>
                {step > 1 && (
                  <CommonButtonBorder 
                    width="200px" 
                    height="48px" 
                    onClick={this.prevStep} 
                    disabled={isSubmitting}
                    style={{
                      position:'absolute', 
                      left:'125px',
                      cursor: isSubmitting ? 'not-allowed' : 'pointer'
                    }}>
                    {t('Back')}
                  </CommonButtonBorder>
                )}
                
                {step === 1 ? (
                  <CommonButtonPopup
                    height="48px" width="200px"
                    onClick={this.nextStep}
                    disabled={!isValid}
                    style={{
                      backgroundColor: isValid ? '#DA6C74' : '#EFEFEF',
                      color: isValid ? '#FFF' : '#666',
                      cursor: isValid ? 'pointer' : 'not-allowed'
                    }}
                  >
                    {t('Next')}
                  </CommonButtonPopup>
                ) : (
                  <CommonButtonPopup
                    height="48px" width="160px"
                    onClick={!isSubmitting ? this.handleSubmit : undefined}
                    disabled={!isValid || isSubmitting}
                    style={{
                      backgroundColor: (isValid && !isSubmitting) ? '#DA6C74' : '#EFEFEF',
                      color: (isValid && !isSubmitting) ? '#FFF' : '#666',
                      cursor: (isValid && !isSubmitting) ? 'pointer' : 'not-allowed'
                    }}
                  >
                    {isSubmitting ? t('Processing...') : buttonText} 
                    {!isSubmitting && <i className="fas fa-check" style={{ marginLeft: '8px' }}></i>}
                  </CommonButtonPopup>
                )}
              </div>
            </Main>
          </ButtonContainer>
        </div>
      </Layout>
    );
  }
}

FormAddVideo.propTypes = {
  state: PropTypes.object.isRequired,
  buttonText: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  video_category_id: PropTypes.array,
  muscle_group: PropTypes.array,
  fitness_level: PropTypes.array,
  themes: PropTypes.array,
  themesHeaderAll: PropTypes.array,
  t: PropTypes.func,
  history: PropTypes.object,
  isSubmitting: PropTypes.bool,
  isAdminRoute:PropTypes.bool,
  location:PropTypes.object
};

FormAddVideo.defaultProps = {
  isSubmitting: false
};

export default withTranslation()(FormAddVideo);